export default "__VITE_ASSET__ejztxRjw__"